import { IStoreState } from "../../../../reducers/types";
import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { MobileEditLocationsModal } from "./component";
import {
  getAdultsCount,
  getChildren,
  getDepartureDate,
  getDestination,
  getFareclassOptionFilter,
  getInfants,
  getOrigin,
  getReturnDate,
  getStopsOption,
  getTravelers,
} from "../../../search/reducer";
import {
  setDestination,
  setOrigin,
  setTravelers,
} from "../../../search/actions/actions";
import {
  resetPackagesAvailabilityCallState,
  setOpenDatesModal,
} from "../../actions/actions";

const mapStateToProps = (state: IStoreState) => {
  return {
    origin: getOrigin(state),
    destination: getDestination(state),
    travelers: getTravelers(state),
    adultsCount: getAdultsCount(state),
    children: getChildren(state),
    infants: getInfants(state),
    departureDate: getDepartureDate(state),
    returnDate: getReturnDate(state),
    stopsOption: getStopsOption(state),
    fareClassFilter: getFareclassOptionFilter(state),
  };
};

const mapDispatchToProps = {
  setOrigin,
  setDestination,
  setOpenDatesModal,
  resetPackagesAvailabilityCallState,
  setTravelers,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileEditLocationModalConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileEditLocationsModal = connector(
  withRouter(MobileEditLocationsModal)
);
